export default class Helper {
	
	/**
	 * Check if an item exist in an arrary before adding.
	 * @param array: Array of items
	 * @param item: Item to be added
	 */
	 static addToArrary<T>(array: Array<T>, key: string, item: any): Array<T> {
		if (array.find((f) => f[key] == item[key]) == null) {
			array.push(item);
		}
		return array;
	}

    static isNullOrEmpty(value: any): boolean {
		if (typeof value === 'string') {
			return value === undefined || value === null || value.trim() === '' || value.trim().length === 0;
		}

		return value == undefined || value == null || value.length === 0;
	}


    static isNullOrWhitespace(value: any): boolean {
		if (value == undefined || value == null || value == '') {
			return true;
		}
		return typeof value === 'string' && value.toString().trim().length === 0;
	}

    static hasObject(value: any): boolean {
		return value !== undefined && value !== null;
	}

	static hasAny(value: any): boolean {
		return !Helper.isNullOrEmpty(value);
	}

    static getFirstOrDefault(array: any[], defaultValue: any = null): any {
		return Helper.hasAny(array) ? array[0] : defaultValue;
	}

	static isValidUrl(input: string): boolean {
		if (Helper.isNullOrEmpty(input)) return true;
		
		const regexp = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/gm);
		return regexp.test(input);	
	}
}